import axios from 'axios';
import { baseUrl, httpUrl, TOKEN_EXPIRED_CODE } from '@/utils/constant'
import { setToken, getToken } from '@/utils/auth'
import { isBlob } from '@/utils'
import routeDescMap from '@/utils/route-desc'
import { Notification } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getPageNameEncoded } from '@/utils/page-cache'

function logout() {
  Notification.warning({
    message: '当前会话已过期，请重新登录',
    duration: 3000,
    onClose: () => {
      store.dispatch('user/logout').then(() => {
        window.location.replace(`${httpUrl}#/login`)
      });
    }
  });
}

function getInitConfig () {
  const config = {
    baseURL: baseUrl,
    headers: {
      Authorization: getToken(),
      'Content-Type': 'application/json;charset=utf-8'
    }
  };
  return config;
}

function getMenuPath() {
  let locationHash = location.hash.substring(1);
  const questionMarkIndex = locationHash.indexOf('?');
  if (questionMarkIndex > -1) {
    locationHash = locationHash.substring(0, questionMarkIndex);
  }
  return routeDescMap[locationHash] || '';
}

const axiosInstance = axios.create(getInitConfig());

axiosInstance.interceptors.request.use(
  config => {
    config.headers.Referer2 = location.href;
    config.headers.menu = getPageNameEncoded(router.currentRoute.path);
    config.headers.Authorization = getToken();
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

axiosInstance.interceptors.response.use(
  response => {
    const accessToken = response.headers['access_token']
    if (accessToken) {
      // console.log('setToken', accessToken);
      setToken(accessToken);
    }

    const { data } = response;
    if (isBlob(data)) {
      return response;
    }

    // 未返回data属性，或code不是 200
    if (!data) {
      const errorMsg = data.message || '异常的响应数据';
      Notification.error({
        message: errorMsg
      })
      return Promise.reject(errorMsg);
    }

    // token过期，退出登录
    if (+data.code === TOKEN_EXPIRED_CODE) {
      logout();
    } else if (data.code && +data.code !== 200) {
      const errorMsg = data.message || '异常的响应数据';
      Notification.error({
        message: errorMsg
      })
      return Promise.reject(errorMsg);
    }

    // TODO 此处可根据code做错误处理，如超时退出 未鉴权
    return data;
  },
  error => {
    let errorInfo = error.response
    let accessToken = '';
    let code = '';

    if (errorInfo) {
      accessToken = errorInfo.headers['access_token']
      code = errorInfo.data && errorInfo.data.code;
    }

    // 错误响应有token时，更新token
    if (accessToken) {
      // console.log('setToken-in-error', accessToken);
      setToken(accessToken);
    }

    if (!errorInfo) {
      errorInfo = {
        data: {
          message: error && error.message || '未知错误'
        }
      }
    }

    // token过期
    if (+code === TOKEN_EXPIRED_CODE) {
      logout();
      return Promise.reject(error)
    }

    // 全局错误通知
    Notification.error({
      message: !errorInfo.data.message ? error.message : errorInfo.data.message
    })
    return Promise.reject(error)
  }
);

export default axiosInstance;